<template>
    <b-card no-body>
        <b-card-body>
            <div class="header-bar">
                <div class="d-flex align-items-center">
                    <b-badge v-if="!isMonitorando" pill variant="secondary" class="px-3 py-2 mr-3 status-badge">
                        <b-icon icon="pause-circle" class="mr-1" />
                        Monitoramento pausado
                    </b-badge>

                    <b-badge v-if="isMonitorando && temPermissaoMonitoramento()" pill variant="success"
                        class="px-3 py-2 mr-3 status-badge status-badge-clickable"
                        v-b-tooltip.hover.bottom="'Clique para pausar o monitoramento'"
                        @click="confirmarPararMonitoramento">
                        <b-icon icon="activity" class="mr-1" />
                        Monitoramento ativo
                    </b-badge>

                    <b-badge v-if="isMonitorando && !temPermissaoMonitoramento()" pill variant="success"
                        class="px-3 py-2 mr-3 status-badge">
                        <b-icon icon="activity" class="mr-1" />
                        Monitoramento ativo
                    </b-badge>

                    <b-button v-if="temPermissaoMonitoramento() && !isMonitorando" size="sm" variant="success"
                        class="mr-2" @click="iniciarMonitoramento">
                        <b-icon icon="play-fill" class="mr-1" />
                        Iniciar
                    </b-button>
                </div>

                <div class="d-flex align-items-center">
                    <b-form-checkbox v-model="live" switch class="mr-3 live-switch">
                        <small>Auto-atualização</small>
                    </b-form-checkbox>

                    <b-button size="sm" variant="outline-primary" :disabled="loading" @click="load"
                        v-b-tooltip.hover.bottom="'Atualizar dados agora'">
                        <b-icon icon="arrow-clockwise" :animation="loading ? 'spin' : ''" />
                    </b-button>
                </div>
            </div>

            <b-alert v-if="!temPermissaoMonitoramento()" show variant="warning" class="mt-3 mb-0">
                <b-icon icon="shield-lock" class="mr-1" />
                Modo somente leitura. Sem permissão para iniciar ou pausar o monitoramento.
            </b-alert>

            <b-alert v-if="loadError" show variant="danger" dismissible class="mt-3 mb-0" @dismissed="loadError = ''">
                {{ loadError }}
            </b-alert>

            <b-card v-if="!isMonitorando" class="empty-state mt-4">
                <b-icon icon="broadcast-pin" variant="secondary" font-scale="3" class="mb-3" />
                <h5>Monitoramento inativo</h5>
                <p class="text-muted mb-3">Inicie o monitoramento para acompanhar eventos RFID em tempo real.</p>
                <b-button v-if="temPermissaoMonitoramento()" variant="success" @click="iniciarMonitoramento">
                    <b-icon icon="play-fill" class="mr-1" />
                    Iniciar monitoramento
                </b-button>
            </b-card>

            <div v-else>
                <b-row class="mt-3">
                    <b-col lg="3" sm="6" class="mb-3">
                        <lg-status-card :value="dashboard.eventosHoje" label="Eventos hoje" icon="calendar-check"
                            variant="primary" />
                    </b-col>
                    <b-col lg="3" sm="6" class="mb-3">
                        <lg-status-card :value="dashboard.leitoresAtivos + '/' + dashboard.leitoresTotal"
                            label="Antenas ativas" icon="broadcast" variant="success" />
                    </b-col>
                    <b-col lg="3" sm="6" class="mb-3">
                        <lg-status-card :value="dashboard.leiturasSucesso" label="Leituras válidas" icon="check-circle"
                            variant="info" />
                    </b-col>
                    <b-col lg="3" sm="6" class="mb-3">
                        <lg-status-card :value="dashboard.leiturasErro" label="Leituras com erro"
                            icon="exclamation-triangle" :variant="dashboard.leiturasErro > 0 ? 'danger' : 'success'" />
                    </b-col>
                </b-row>

                <b-tabs content-class="mt-3">
                    <b-tab>
                        <template #title>
                            <b-icon icon="camera-video" class="mr-1" />
                            Eventos
                        </template>

                        <b-form-row class="filter-row" @keyup.enter="load">
                            <b-col md="4" lg="3">
                                <LgFinderPageUnidadeAdministrativa :prefix="prefix + title + ' > '"
                                    v-model="form.departamento" label="Departamento:"
                                    @onselect="handleSelectUnidadeAdministrativa" />
                            </b-col>

                            <b-col md="4" lg="3">
                                <LgFinderPageLocalArmazenamento :prefix="prefix + title + ' > '" v-model="form.local"
                                    label="Local:" @input="handleLocal" />
                            </b-col>

                            <b-col md="4" lg="3">
                                <LgFinderPageLeitor id="leitorMonitoramento1" :prefix="prefix + title + ' > '"
                                    v-model="form.leitor" label="Leitor:" @close="handleSetor" />
                            </b-col>

                            <b-col md="4" lg="3">
                                <lg-form-input v-model="form.tombamento" label="Etiqueta:" description=" " />
                            </b-col>
                        </b-form-row>

                        <b-form-row class="filter-row" @keyup.enter="load">
                            <lg-form-date sm="3" description="" v-model="form.dataDe" label="Data inicial:" />
                            <lg-form-date sm="3" description="" v-model="form.dataAte" label="Data final:" />

                            <b-col cols="2" class="mt-3 d-flex align-items-center justify-content-center">
                                <div :id="'relatorioXLSX-'">
                                    <img @click="gerarRelatorio('EXCEL')" :src="xlsIcon" class="img img--clickable"
                                        alt="XLSX" />
                                    <b-tooltip :target="'relatorioXLSX-'" title="Relatório em XLS" />
                                </div>

                            </b-col>



                        </b-form-row>

                        <div class="d-flex align-items-center mb-3">
                            <b-button size="sm" variant="primary" class="mr-2" @click="load">
                                <b-icon icon="search" class="mr-1" />
                                Buscar
                            </b-button>
                            <b-link class="text-muted small" href="#" @click.prevent="limpar">
                                <b-icon icon="x-circle" class="mr-1" />
                                Limpar filtros
                            </b-link>
                        </div>

                        <b-table :items="records" :fields="fields" responsive bordered hover show-empty :busy="loading">
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template #cell(antena)="data">
                                {{ data.item.antena + (data.item.descricaoAntena ? (" - " + data.item.descricaoAntena) :
                                    "") }}
                            </template>

                            <template #cell(tipoEventoLeituraLeitor)="data">
                                <b-badge :variant="getVariant(data.item.codTipoEventoLeituraLeitor)" class="p-2">
                                    <b-icon :icon="getIcon(data.item.codTipoEventoLeituraLeitor)" class="mr-1" />
                                    {{ data.item.tipoEventoLeituraLeitor }}
                                </b-badge>
                            </template>
                        </b-table>

                        <div class="pagination-bar">
                            <small class="text-muted">
                                Página {{ page }} de {{ totalPage }} &mdash; {{ total }} registros
                            </small>
                            <div class="d-flex align-items-center">
                                <small class="text-muted mr-2">Por página:</small>
                                <b-form-select size="sm" v-model="perPage" @change="onPerPageChange"
                                    :options="perPageOptions" style="width: 70px" />
                            </div>
                            <b-pagination size="sm" v-model="page" :per-page="perPage" :total-rows="total"
                                class="mb-0" />
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <b-icon icon="gear" class="mr-1" />
                            Leitores e antenas
                        </template>
                        <TabDetalheMonitoramentoRfidList :prefix="prefix" />
                    </b-tab>
                </b-tabs>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgStatusCard from "@/core/components/Cards/LgStatusCard.vue"
import xlsIcon from "@/core/assets/icons/xls.png";

import moment from "moment"
import ResourceService from "@/core/api/ResourceService";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFinderPageLeitor from "@/components/Finders/LgFinderPageLeitor.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import TabDetalheMonitoramentoRfidList from "./TabDetalheMonitoramentoRfidList.vue";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";

import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"


export default {
    components: {
        LgFormInput,
        LgFormDate,
        LgStatusCard,
        LgFinderPageLeitor,
        LgFinderPageLocalArmazenamento,
        LgFinderPageUnidadeAdministrativa,
        TabDetalheMonitoramentoRfidList
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },

    mixins: [ListResourceMixin, ConfirmMixin],
    data() {
        return {
            loading: false,
            loadError: "",
            isOpen: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            pollTimer: null,
            xlsIcon: xlsIcon,

            dashboard: {
                eventosHoje: 0,
                leitoresAtivos: 0,
                leitoresTotal: 0,
                leiturasSucesso: 0,
                leiturasErro: 0,
            },

            fields: [
                { key: 'etiqueta', label: 'Etiqueta' },
                { key: 'descricaoDetalhada', label: 'Descrição' },
                { key: 'departamento', label: 'Departamento' },
                { key: 'localArmazenamento', label: 'Local' },
                { key: 'leitor', label: 'Leitor' },
                { key: 'antena', label: 'Antena' },
                { key: 'tipoAntena', label: 'Tipo Antena' },
                {
                    key: 'dhLeitura',
                    label: 'Data Leitura',
                    formatter: value => !value || value === '' ? '' : moment(value).format("DD/MM/YYYY HH:mm"),
                },
                { key: 'tipoEventoLeituraLeitor', label: 'Status' }
            ],
            title: 'Monitoramento rfid - Antenas',
            isMonitorando: false,
            live: true,
            filtro: {},
            form: {
                departamento: {},
                dataDe: "",
                dataAte: "",
                local: {},
                leitor: {},
                tombamento: "",
            },
        }
    },
    methods: {

        temPermissaoMonitoramento() {
            return verificaPrivilegio(PrivilegiosEnum.MONITORAMENTO_RFID_ANTENAS_MONITORAMENTO);
        },
        getVariant(cod) {
            switch (cod) {
                case 8: return "warning";
                case 7: return "warning";
                case 6: return "success";
                case 5: return "info";
                case 4: return "warning";
                case 3: return "warning";
                case 2: return "danger";
                case 1: return "secondary";
                default: return "light";
            }
        },
        getIcon(cod) {
            switch (cod) {
                case 8: return "box-arrow-down";
                case 7: return "box-arrow-up";
                case 6: return "check-circle";
                case 5: return "arrow-right-circle";
                case 4: return "box-arrow-down";
                case 3: return "box-arrow-up";
                case 2: return "exclamation-triangle";
                case 1: return "x-circle";
                default: return "question-circle";
            }
        },

        handleSetor(setor) {
            this.form.leitor = setor || {};
            this.load();
        },
        handleLocal(local) {
            this.form.local = local;
            this.load();

        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
            this.load();

        },

        limpar() {
            this.form.departamento = {};
            this.form.local = {};
            this.form.leitor = {};
            this.form.tombamento = "";
            this.form.dataDe = "";
            this.form.dataAte = "";
            this.page = 1;
            this.load();
        },
        onPerPageChange() {
            this.page = 1;
            this.load();
        },

        async iniciarMonitoramento() {
            try {
                await this.$serviceMonitorando.put("start-monitorando");
                this.isMonitorando = true;
                this.$notify({ type: "success", message: "Monitoramento iniciado com sucesso." });
                this.load();
            } catch (error) {
                this.$notify({ type: "danger", message: "Não foi possível iniciar o monitoramento." });
            }
        },
        async confirmarPararMonitoramento() {
            const confirmado = await this.$confirm(
                "Pausar monitoramento?",
                "Ao pausar, os leitores RFID deixarão de registrar eventos. Deseja continuar?"
            );
            if (confirmado) {
                this.pararMonitoramento();
            }
        },
        async pararMonitoramento() {
            try {
                await this.$serviceMonitorando.put("stop-monitorando");
                this.isMonitorando = false;
                this.$notify({ type: "success", message: "Monitoramento pausado com sucesso." });
            } catch (error) {
                this.$notify({ type: "danger", message: "Não foi possível pausar o monitoramento." });
            }
        },

        buildFiltro() {
            const filtro = {};
            if (this.form.dataDe)
                filtro.dataInicio = moment(String(this.form.dataDe)).format("DD/MM/YYYY");
            if (this.form.dataAte)
                filtro.dataFim = moment(String(this.form.dataAte)).format("DD/MM/YYYY");
            if (this.form.departamento && this.form.departamento.id)
                filtro.departamento = this.form.departamento.id;
            if (this.form.local && this.form.local.id)
                filtro.local = this.form.local.id;
            if (this.form.leitor && this.form.leitor.id)
                filtro.leitor = this.form.leitor.id;
            if (this.form.tombamento && this.form.tombamento !== "")
                filtro.tombamento = this.form.tombamento;
            return filtro;
        },

        async loadDashboard() {
            try {
                const [sucessoRes, erroRes, monitorRes] = await Promise.all([
                    this.$service.getWithParams("com-sucesso", this.filtro),
                    this.$service.getWithParams("com-erro", this.filtro),
                    this.$serviceMonitorando.get('todas-antenas'),
                ]);
                this.dashboard.leiturasSucesso = sucessoRes.data || 0;
                this.dashboard.leiturasErro = erroRes.data || 0;
                this.dashboard.eventosHoje = (sucessoRes.data || 0) + (erroRes.data || 0);

                const leitores = monitorRes.data || [];
                console.log(leitores)
                this.dashboard.leitoresTotal = leitores.length;
                this.dashboard.leitoresAtivos = leitores.filter(l =>
                    l.situacao == 1
                ).length;

            } catch (_) {
                /* dashboard stats are non-critical */
            }

        },
        async gerarRelatorio(tipoRelatorio) {

            this.busy = true;
            const resource = new ResourceService('/api/relatorio/gerar-relatorio-monitoramento');
            const { data } = await resource.getWithParams(`${tipoRelatorio}`, this.buildFiltro());
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;

        },


        async load() {
            if (this.loading) return;
            this.loading = true;
            this.loadError = "";
            this.filtro = this.buildFiltro();

            try {
                await this.$loadResource({
                    size: this.perPage,
                    page: this.page,
                    params: this.filtro,
                });
                await this.loadDashboard();
            } catch (error) {
                this.loadError = "Não foi possível carregar os dados de monitoramento.";
            } finally {
                this.loading = false;
            }
        },

        startPolling() {
            this.pollTimer = setTimeout(async () => {
                if (this.live && this.isMonitorando && !document.hidden) {
                    await this.load();
                }
                this.startPolling();
            }, 5000);
        },
    },

    watch: {
        page() {
            this.load();
        },
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/evento-leitura-leitor`);
        this.$serviceMonitorando = new ResourceService(`/api/monitoramento`);

        try {
            const { data } = await this.$serviceMonitorando.get("is-monitorando");
            this.isMonitorando = data;
        } catch (error) {
            this.isMonitorando = false;
            this.$notify({ type: "danger", message: "Não foi possível obter o status do monitoramento." });
        }

        if (this.isMonitorando) this.load();
        this.startPolling();
    },
}
</script>

<style scoped>
.header-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid #e9ecef;
}

.status-badge {
    font-size: 13px;
}

.status-badge-clickable {
    cursor: pointer;
    transition: opacity 0.2s;
}

.status-badge-clickable:hover {
    opacity: 0.8;
}

.live-switch {
    user-select: none;
}

.empty-state {
    text-align: center;
    border: 2px dashed #dee2e6;
    background: #fafbfc;
    padding: 3rem 1rem;
}

.filter-row {
    margin-bottom: 12px;
}

.pagination-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 12px;
    border-top: 1px solid #e9ecef;
}
</style>
